/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../../extendIcon';

const ExportPDF = props => (
  <svg
    viewBox="0 0 128 128"
    width="1em"
    height="1em"
    {...props}
    cursor="pointer"
  >
    <title>{props.title || 'PDF'}</title>
    <path
      d="M114.161,32.897L82.157,0.893C81.586,0.321,80.81,0,80.002,0H25.138c-6.649,0-13.716,3.738-13.716,10.668v103.63
	c0,6.666,7.05,13.718,13.716,13.718h79.249c6.929,0,10.668-7.066,10.668-13.718V35.052
	C115.055,34.244,114.732,33.468,114.161,32.897z M81.525,8.882l24.646,24.646H89.146c-3.347,0-7.621-4.273-7.621-7.62V8.882z
	 M108.958,114.298c0,3.073-1.452,7.622-4.571,7.622H25.138c-3.347,0-7.62-4.276-7.62-7.622V10.668c0-3.12,4.546-4.572,7.62-4.572
	H75.43v19.812c0,6.667,7.051,13.716,13.717,13.716h19.812V114.298z M79.383,72.93c-5.296-5.297-11.272-12.631-16.366-20.097
	c1.16-5.874,1.748-10.316,1.748-13.208c0-13.007-15.241-13.007-15.241,0c0,2.549,2.357,7.42,7.013,14.487
	c-1.926,9.158-4.849,20.078-7.801,29.14c-6.636,2.904-11.193,5.573-13.558,7.938c-3.041,3.039-3.962,7.014-2.464,10.627
	c1.352,3.265,4.422,5.453,7.644,5.453c1.95,0,3.76-0.776,5.227-2.244c0.841-0.843,3.35-3.349,8.07-17.242
	c8.097-3.352,17.438-6.365,23.954-8.113c5.893,5.419,10.676,8.055,14.59,8.055c4.434,0,8.041-3.325,8.041-7.414
	c0-2.53-1.449-4.836-3.975-6.328c-2.432-1.436-5.85-2.164-10.162-2.164C84.738,71.818,82.484,72.191,79.383,72.93z M41.271,100.715
	c-0.411,0.413-0.721,0.459-0.917,0.459c-0.645,0-1.573-0.631-2.012-1.691c-0.379-0.913-0.489-2.349,1.143-3.981
	c0.767-0.765,2.515-2.157,6.412-4.166C43.76,96.901,42.164,99.822,41.271,100.715z M55.618,39.624c0-2.66,1.009-3.81,1.524-3.81
	s1.524,1.15,1.524,3.81c0,1.332-0.172,3.21-0.503,5.515C56.26,41.779,55.664,40.066,55.618,39.624z M56.06,80.271
	c1.902-6.258,3.723-13.035,5.206-19.364c3.68,5.01,7.628,9.807,11.381,13.82C67.849,76.119,61.95,78.028,56.06,80.271z
	 M94.141,80.311c0,0.525-0.777,1.319-1.947,1.319c-0.862,0-3.036-0.425-7.146-3.621c0.474-0.065,0.821-0.096,1.05-0.096
	c4.206,0,6.23,0.824,7.063,1.316C93.766,79.59,94.141,80.002,94.141,80.311z"
    />
  </svg>
);

export default extendIcon(ExportPDF);
